import { FC } from "react";
import { clsx } from "clsx";
import s from "./ProgressBar.module.scss";
import { ProgressBarPropsT } from "./types";

export const ProgressBar: FC<ProgressBarPropsT> = ({ value, className }) => {
  const clampedValue = Math.min(100, Math.max(0, value));
  return (
    <div className={clsx(s.wrap, className)}>
      <div className={s.progressOuter}>
        <span className={s.progressText}>{`${clampedValue}%`}</span>
        <div
          className={s.progressInner}
          style={{
            width: `${clampedValue}%`,
            background: "#b57345",
          }}
        />
      </div>
    </div>
  );
};
